import { playerRefKey } from './galiPlayerRefs';

export const validateQuickMatch = ({ teamA = {}, teamB = {}, commonPlayer = null, overs }) => {
  const errors = [];
  if (!Number(overs) || Number(overs) <= 0) errors.push('Overs is required.');
  if (!teamA.captainRef) errors.push('Team A captain is required.');
  if (!teamB.captainRef) errors.push('Team B captain is required.');

  const teamAKeys = new Set((teamA.players || []).map(playerRefKey).filter(Boolean));
  const teamBKeys = new Set((teamB.players || []).map(playerRefKey).filter(Boolean));
  const commonKey = commonPlayer ? playerRefKey(commonPlayer) : '';

  if (teamA.captainRef && !teamAKeys.has(playerRefKey(teamA.captainRef))) errors.push('Team A captain must be in Team A.');
  if (teamB.captainRef && !teamBKeys.has(playerRefKey(teamB.captainRef))) errors.push('Team B captain must be in Team B.');

  teamAKeys.forEach((key) => {
    if (teamBKeys.has(key) && key !== commonKey) errors.push('Same participant cannot be in both teams unless set as Common.');
  });

  return errors;
};

export const canAddPlayerToTeam = ({ ref, teamA = [], teamB = [], commonPlayer = null, target }) => {
  const key = playerRefKey(ref);
  if (!key) return { allowed: false, reason: 'Invalid player reference.' };
  const commonKey = commonPlayer ? playerRefKey(commonPlayer) : '';
  const inA = teamA.map(playerRefKey).includes(key);
  const inB = teamB.map(playerRefKey).includes(key);
  if (target === 'teamA' && inA) return { allowed: false, reason: 'Already in Team A.' };
  if (target === 'teamB' && inB) return { allowed: false, reason: 'Already in Team B.' };
  if (target === 'teamA' && inB && key !== commonKey) return { allowed: false, reason: 'Set as Common to use on both teams.' };
  if (target === 'teamB' && inA && key !== commonKey) return { allowed: false, reason: 'Set as Common to use on both teams.' };
  return { allowed: true, reason: '' };
};
